import { GraphQLReturn } from '@cherre-frontend/data-fetching';
import { graphql } from 'react-relay';
import { useModelTableUpdateMutation } from './__generated__/useModelTableUpdateMutation.graphql';

export const useModelTableUpdate = graphql`
  mutation useModelTableUpdateMutation(
    $targetTableDefinitionName: String!
    $displayName: String!
    $description: String
    $dsp: TargetTableDspDefinitionInput
    $columns: [ColumnInput!]!
  ) {
    updateTargetTableDefinition(
      targetTableDefinitionName: $targetTableDefinitionName
      displayName: $displayName
      description: $description
      dsp: $dsp
      columns: $columns
    ) {
      name
      description
      displayName
      uid
      owner {
        name
      }
      dsp {
        submissionType
        orgSlug
      }
      columns {
        name
        displayName
        type
        description
        dsp {
          required
          mappingFields {
            mappingName
            mappingValue
            targetName
            displayName
            displayPreference
            descriptionName
            required
            tsa {
              required
              enabled
            }
          }
          tsa {
            required
            enabled
          }
        }
      }
    }
  }
` as GraphQLReturn<useModelTableUpdateMutation>;
